import React from 'react'
import Svg, { G, Path, SvgProps } from 'react-native-svg'

import { Color } from '../../style'

export interface Props extends SvgProps {}
const IconClock = (props: Props) => {
  const { width, height, color, ...otherProps } = props
  return (
    <Svg
      width={width}
      height={height}
      viewBox={`0 0 ${IconClock.dimensions.width} ${IconClock.dimensions.height}`}
      {...otherProps}
    >
      <G fill={color || Color.premiumBlack} fillRule="nonzero">
        <Path d="M9.66 5.375v7.06a.665.665 0 101.33 0v-7.06a.665.665 0 10-1.33 0z" />
        <Path d="M13.743 15.154l-2.93-3.17a.665.665 0 00-.976.902l2.93 3.17a.665.665 0 00.976-.902z" />
        <Path d="M11.125 0C17.269 0 22.25 4.98 22.25 11.125c0 6.144-4.98 11.125-11.125 11.125C4.981 22.25 0 17.27 0 11.125 0 4.981 4.98 0 11.125 0zm0 1.33c-5.41 0-9.795 4.385-9.795 9.795s4.385 9.795 9.795 9.795 9.795-4.385 9.795-9.795-4.385-9.795-9.795-9.795z" />
      </G>
    </Svg>
  )
}

IconClock.dimensions = {
  width: 23,
  height: 23,
}

export default IconClock
